import { Component } from '@angular/core';
import {MSMEUserModel} from './../../../../shared/models/MSMEUserModel';
import { Router } from '@angular/router';
import { ApiService } from './../../../../shared/services/api.service';
import { API_ENDPOINTS } from './../../../../shared/utils/const';
import { CommonService } from '../../../../shared/services/common.service';


@Component({
  selector: 'app-leftcolWebsite',
  templateUrl: './leftcol.component.html',
  styleUrl: './leftcol.component.css'
})



export class LeftcolComponent {

  userType = sessionStorage.getItem('UserType');
  name = sessionStorage.getItem('name');
  msMeUserName = sessionStorage.getItem('msMeUserName');
  isProfileCompleted = sessionStorage.getItem('isProfileCompleted')==='true'? true: false;
  loggedInUserName = sessionStorage.getItem('name');

  data: any[] = [];

  usr_obj!: MSMEUserModel;

  constructor(private router: Router, private apiService: ApiService, public commonService: CommonService) { }

  ngOnInit(): void {
    this.CheckUserType();   
   
  }

  navigatetopage() {
    sessionStorage.setItem('readonlyUsername', JSON.stringify(this.name));
    //sessionStorage.setItem('singInAs', this.userType?.toString());

    //alert("user name is "+sessionStorage.getItem('readonlyUsername'));
    this.router.navigateByUrl("/changepassword");
  }

  //navigatetoInterestpage() {
  //  this.router.navigateByUrl("masters/interest");

  //}
  //navigatetoUsertTypepage() {
  //  this.router.navigateByUrl("masters/usertype");
  //}

  //navigatetoDistrictpage() {
  //  this.router.navigateByUrl("masters/district");
  //}

  dic_navigate(event: any) {
    const buttonId = event.target.id;

    switch (buttonId) {
      case 'btnDICDashboard':
        this.router.navigate(['/dicdashboard']);
        break;
      case 'btnViewEvents':
        this.router.navigate(['/reports/alltotaleventlist']);
        break;
        
      case 'btnMssidcUserList':
        this.router.navigate(['/reports/mssidcuserlist']);
        break;
      case 'btnRegisteresIAList':
        this.router.navigate(['/reports/allregisteredialist']);
        break;
      case 'btnRegisteresMSMEList':
        this.router.navigate(['/reports/allregisteredmsmelist']);
        break;
      case 'btnTotalEventList':
        this.router.navigate(['/reports/alltotaleventlist']);
        break;
      case 'btnCompletedEventList':
        this.router.navigate(['/reports/allcompletedeventlist']);
        break;
      case 'btnScheduledEventList':
        this.router.navigate(['/reports/allscheduledeventlist']);
        break;
      case 'btnCancelPostponeEventList':
        this.router.navigate(['/reports/allcancelpostponeeventlist']);
        break;
      case 'btnDistrictWiseTrainingList':
        this.router.navigate(['/reports/districtwisetraining']);
        break;
      case 'btnDistrictCategoryWiseTrainingList':
        this.router.navigate(['/reports/districtcategorywisetraining']);
        break;
      case 'btnTotalProposalList':
        this.router.navigate(['/reports/alltotalproposallist']);
        break;
      case 'btnIaBankDetails':
        this.router.navigate(['/reports/iabankdetails']);
        break;
      case 'btnCompletedInvoiceList':
        this.router.navigate(['/reports/completedinvoice']);
        break;

      case 'btnDICChangePassword':
        this.router.navigate(['/changepassword']);
        break;
      case 'btnMDCDetails':
        this.router.navigate(['master/msmecertificate']);
        break;

      default:
        window.location.reload();
        break;

    }
  }

  mssidc_navigate(event: any) {
    const buttonId = event.target.id;
    switch (buttonId) {
      case 'btnMSSIDCDashboard':
        this.router.navigate(['/mssidcdashboard']);
        break;
      case 'btnVerifyMSME':
        this.router.navigate(['/msmeverification']);
        break;
      case 'btnViewEvents':
        this.router.navigate(['/viewallevents']);
        break;
      case 'btnOnSpotAttendance':
        this.router.navigate(['/Spot-Attendance-file']);
        break;
      // case 'btnChangeEventDate':
      //   this.router.navigate(['/Update-Event-Date']);
      //   break;

              case 'btnChangeEventDate':
        this.router.navigate(['/Update-Event-Date-List']);
        break;

               case 'btnUpdateAttendanceList':
        this.router.navigate(['/Msme-Attendance-List']);
        break;

                  case 'btnUpdateLoginBanner':
        this.router.navigate(['/Login-Banner-List']);
        break;
        
        
      case 'btnViewProposal':
        this.router.navigate(['/mssidcdashboard']);
        //this.router.navigate(['/mssidcproposalpage']);
        break;
      case 'btnBlockMaster':
        this.router.navigate(['/masters/block']);
        break;
      case 'btnCityMaster':
        this.router.navigate(['/masters/city']);
        break;
      case 'btnDistrictMaster':
        this.router.navigate(['/masters/district']);
        break;
      case 'btnFocusSectorMaster':
        this.router.navigate(['/masters/focussector']);
        break;
      case 'btnFundMngtMaster':
        this.router.navigate(['/masters/fundManagement']);
        break;
      case 'btnGreenTechMaster':
        this.router.navigate(['/masters/greentechnology']);
        break;
      case 'btnInterestMaster':
        this.router.navigate(['/masters/interest']);
        break;
      case 'btnInterventionMaster':
        this.router.navigate(['/masters/intervention']);
        break;
      case 'btnISOCertiMaster':
        this.router.navigate(['/masters/ISOCertificate']);
        break;
      case 'btnNICMaster':
        this.router.navigate(['/masters/nic']);
        break;
      case 'btnOrganisationTypeMaster':
        this.router.navigate(['/masters/organisationtype']);
        break;
      case 'btnSocialCategoryMaster':
        this.router.navigate(['/masters/socialcategory']);
        break;
      case 'btnStateMaster':
        this.router.navigate(['/masters/state']);
        break;
      case 'btnTypeEnterpriseMaster':
        this.router.navigate(['/masters/enterprise']);
        break;
      case 'btnUserTypeMaster':
        this.router.navigate(['/dynamicDashboard']);
        break;
      case 'btnVerifyProposal':
        this.router.navigate(['/proposalverification']);
        break;


      case 'btnGrievanceMaster':
        this.router.navigate(['/masters/grievance']);
        break;
      case 'btnEventCapacityMaster':
        this.router.navigate(['/masters/eventcapacity']);
        break;

      case 'btnUserMaster':
        this.router.navigate(['/masters/usermaster']);
        break;
      case 'btnGrievancesDashboardMSSIDC':
        this.commonService.searchText = '';
        this.router.navigate(['/mssidcGrievanceDashboard']);
        break;
      case 'btnInvoiceDashboardMSSIDC':
        this.router.navigate(['/invoicedashboardmssidc']);
        break;
      case 'btnGrading':
        this.router.navigate(['/grading']);
        break;
      case 'btnMSSIDCEOI':
        this.router.navigate(['/eoi-list']);
        break;
      case 'btnMSSIDCEOIExhibition':
        this.router.navigate(['/eoiexhibition-list']);
        break;
      case 'btnCustomeFeedback':
        this.router.navigate(['/customiseFeefback']);
        break;

      case 'btnRepositorymssidc':
        this.router.navigate(['/mssidcrepository']);
        break;
      case 'btnCustomeFeedbackCreate':
        this.router.navigate(['/customiseFeefbackCreate']);
        break;

      case 'btnMssidcUserList':
        this.router.navigate(['/report/mssidcuserlist']);
        break;
      case 'btnRegisteresIAList':
        this.router.navigate(['/report/allregisteredialist']);
        break;
      case 'btnRegisteresMSMEList':
        this.router.navigate(['/report/allregisteredmsmelist']);
        break;
      case 'btnTotalEventList':
        this.router.navigate(['/report/alltotaleventlist']);
        break;
      case 'btnCompletedEventList':
        this.router.navigate(['/report/allcompletedeventlist']);
        break;
      case 'btnScheduledEventList':
        this.router.navigate(['/report/allscheduledeventlist']);
        break;
      case 'btnCancelPostponeEventList':
        this.router.navigate(['/report/allcancelpostponeeventlist']);
        break;
      case 'btnDistrictWiseTrainingList':
        this.router.navigate(['/report/districtwisetraining']);
        break;
      case 'btnDistrictCategoryWiseTrainingList':
        this.router.navigate(['/report/districtcategorywisetraining']);
        break;
      case 'btnTotalProposalList':
        this.router.navigate(['/report/alltotalproposallist']);
        break;
      case 'btnIaBankDetails':
        this.router.navigate(['/report/iabankdetails']);
        break;
      case 'btnCompletedInvoiceList':
        this.router.navigate(['/report/completedinvoice']);
        break;

      case 'btnParticipantList':
        this.router.navigate(['/report/participantdetails']);
        break;
      case 'btnMISDetails':
        this.router.navigate(['/report/misdetails']);
        break;
      case 'btnMSSIDCChangePassword':
        this.router.navigate(['/changepassword']);
        break;

      case 'btnMSMEUserManual':
        this.router.navigate(['/mssidcdashboard', 'MSME']);
        break;
      case 'btnIAUserManual':
        this.router.navigate(['/mssidcdashboard', 'IA']);
        break;
      case 'btnDynamicDashboard':
        this.router.navigate(['/dynamicDashboard']);
        break;
      default:
        window.location.reload();
        break;
    }
  }
  ia_navigate(event: any) {

    {
      const buttonId = event.target.id;

      switch (buttonId) {
        case 'btnIADashboard':
          this.router.navigate(['/iauserdashboard']);
          break;
        case 'btnIAProfile':
          this.router.navigate(['/iaprofile']);
          break;
        case 'btnIAOtherDetails':
          this.router.navigate(['/iaquestionanswer']);
          break;
        case 'btnCreateEvents':
          this.router.navigate(['/iaeventcreate']);
          break;
        case 'btnIAViewProposal':
          this.router.navigate(['/iaproposalpage']);
          break;
        case 'btnIAFeedBack':
          this.router.navigate(['/iaprofile']);
          break;
        case 'btnGrievancesDashboardIA':
          this.commonService.searchText = '';
          this.router.navigate(['/iagrievanceDashboard']);
          break;
        case 'btnReverseBS':
          this.router.navigate(['/reversebuyerseller']);
          break;
        case 'btnRepository':
          this.router.navigate(['/repositorycontetnt']);
          break;
        case 'btnIAChangePassword':
          this.router.navigate(['/changepassword']);
          break;
        case 'btnViewEvent':
          this.router.navigate(['/view_event']);
          break;
        case 'btnInvoiceDashboardIA':
          this.router.navigate(['/invoicedashboardia']);
          break;
        case 'btnUserManual':
          this.router.navigate(['/iauserdashboard', 'usermanual']);
          break;
        default:
          window.location.reload();
          break;
      }
    }
  }

  msme_navigate(event: any) {

    const buttonId = event.target.id;

    switch (buttonId) {
      case 'btnMSMEDashboard':
        this.router.navigate(['/msmeuserdashboard']);
        break;
      case 'btnMSMEProfile':
        this.router.navigate(['/msmeuserprofile']);
        break;
      case 'btnMSMEOtherDetails':
        this.router.navigate(['/otheruserdetails']);
        break;
      case 'btnMSMEViewEvents':
        this.commonService.searchText = '';
        this.router.navigate(['/vieweventlist']);
        break;
      case 'btnMSMEEnrollToEvent':
        this.router.navigate(['/enrollnewevent']);
        break;
      case 'btnMSMEFeedBack':
        this.router.navigate(['/feedbackform']);
        break;
      case 'btnGrievances':
        this.commonService.searchText = '';
        this.router.navigate(['/grievanceDashboard']);
        break;
      case 'btnFlattenedGala':
        this.router.navigate(['/viewflattedgala']);
        break;
      
      case 'btnMSMESubmitGrievance':
        this.router.navigate(['/submitgrievance']);
        break;
      case 'btnRepositoryContetnt':
        this.commonService.searchText = '';
        this.router.navigate(['/msmerepositorycontent']);
        break;
      case 'btnMSMEChangePassword':
        this.router.navigate(['/changepassword']);
        break;
      case 'btnUserManual':
        this.router.navigate(['/msmeuserdashboard', 'usermanual']);
        break;      
      default:
        window.location.reload();
        break;
    }
  }


  

 

  Logout() {
    this.commonService.logout();
    //sessionStorage.clear();
    //this.router.navigateByUrl("/login").then(() => {
    //  window.history.pushState(null, '', window.location.href);
    //});
  }

  isDrop: boolean = false;

  toggleDrop() {
    this.isDrop = !this.isDrop;
  }


  isMSMEUser: boolean = false;
  isIAUser: boolean = false;
  isMSSIDCUser: boolean = false;
  isDICUser: boolean = false;

  
  CheckUserType() {
    if (this.userType === 'MSSIDC') {
      this.isMSSIDCUser = true;
    }
    else if (this.userType === 'MSME') {
      this.isMSMEUser = true;
    }
    else if (this.userType === 'IA') {
      this.isIAUser = true;
    }
    else if (this.userType === 'DIC') {
      this.isDICUser = true;
    }
    else {
      this.isMSMEUser  = false;
      this.isIAUser =false;
      this.isMSSIDCUser = false;
      this.isDICUser= false;
    }
  }

  isMasterSubMenuVisible: boolean = false;
  isReportSubMenuVisible: boolean = false;
  isMyProfileSubMenuVisible: boolean = false;
  isUserManualSubMenuVisible: boolean = false;

  // Function to toggle the visibility of the submenu
  toggleMasterSubMenu() {
    this.isMasterSubMenuVisible = !this.isMasterSubMenuVisible;
    this.isReportSubMenuVisible =false;
  }
  toggleReportSubMenu() {
    this.isReportSubMenuVisible = !this.isReportSubMenuVisible;
    this.isMasterSubMenuVisible = false;
  }

  toggleMSMEProfileSubMenu() {
    this.isMyProfileSubMenuVisible = !this.isMyProfileSubMenuVisible;
  }

  toggleUserManualSubMenu() {
    this.isUserManualSubMenuVisible = !this.isUserManualSubMenuVisible;
    //this.isUserManualSubMenuVisible = false;
  }


  openIAUserManual() {
    var filePath = 'Images\\UserManual\\IA\\RAMP-Portal-UserManul-For-V1-IA.pdf';
    var fileName = 'RAMP-Portal-UserManul-For-V1-IA.pdf';
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }

  openMSMEUserManual() {
    var filePath = 'Images\\UserManual\\MSME\\RAMP-Portal-UserManul-For-V1-MSME.pdf';
    var fileName = 'RAMP-Portal-UserManul-For-V1-MSME.pdf';
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }
  get normalizedUserType(): string {
    return (this.userType || '').trim().toLowerCase();
  }
}
